import crypto from "crypto"
// export function getJsonForGql(data) {
//     return JSON.stringify(data).replace(/"([^(")"]+)":/g, '\\"$1\\":');
// }

export function getXMLString(value) {
    if (!value) {
        return ""
    }
    let localValue = value.replace(/&/g, "")
    localValue = localValue.replace(/</g, "")
    localValue = localValue.replace(/>/g, "")
    localValue = localValue.replace(/ /g, "")
    localValue = localValue.replace(/'/g, "")
    localValue = localValue.replace(/"/g, "")
    localValue = localValue.replace(/_/g, "-")
    localValue = localValue.replace(/\(/g, "")
    localValue = localValue.replace(/\)/g, "")

    // let localValue = value.replace(/&/g, "&amp;")
    // localValue = localValue.replace(/</g, "&lt;")
    // localValue = localValue.replace(/>/g, "&gt;")
    // localValue = localValue.replace(/ /g, "")
    // localValue = localValue.replace(/'/g, "&apos;")
    // localValue = localValue.replace(/"/g, "&quot;")

    localValue = localValue.replace(/[éèêë]/g, "e");
    localValue = localValue.replace(/[àâä]/g, "a");
    localValue = localValue.replace(/[îï]/g, "i");
    localValue = localValue.replace(/[ôö]/g, "o");
    localValue = localValue.replace(/[ùûü]/g, "u");
    localValue = localValue.replace(/[ç]/g, "c");
    localValue = localValue.replace(/[ñ]/g, "n");

    localValue = localValue.replace(/[‘’]/g, "&apos;");
    localValue = localValue.replace(/[“”«»]/g, "&quot;");
    localValue = localValue.replace(/[€]/g, "EUR");
    localValue = localValue.replace(/[©]/g, "(c)");
    localValue = localValue.replace(/[®]/g, "(r)");


    return localValue.trim()
}

export function getArrayForGql(data) {
    return JSON.stringify(data).replace(/"([^(")"]+)":/g, "$1:");
}

const dict = {

    "á": "a",
    "â": "a",
    "à": "a",
    "à": "a",
    "é": "e",
    "è": "e",
    "ë": "e",
    "î": "i",
    "ï": "i",
    "ô": "o",
    "ù": "u",
    "û": "u",
    "ç":"c"}

export function cleanString(text) {
    if (!text) return text
    let value = text

    for (const key in dict) {
        const regExp = new RegExp(key, "gm")
        value = value.replace(regExp, dict[key])
    }
    // value = value.replace(/(\w)/g, char => dict[char] || char)
    return value
}

export function modifyStringForFileName(text) {
    if (!text) return text
    let value = cleanText(text)
    value = value.replace(/([%&{}}\<>*?/$!'":@+`|=])/gmi, '-')

    return value
}

export function cleanText(text) {
    let lText = cleanSearch(text)
    lText = lText.replace(/\n/g, " ")
    if (lText) {
        lText = lText.replace(/\r/g, " ")
    }
    if (lText) {
        lText = lText.replace(/\t/g, " ")
    }
    return lText
}

export function cleanSearch(word) {
    if (!word) {
        return ""
    }
    let cw = word.replace(/^ {1,}/, '')
    cw = cw.replace(/ {1,}$/, '')
    return cw
}


export function getSiretValue(siret: string) {
    if (!siret) {
        return "";
    }
    return siret.split("_")?.[0]
}


export function getSHA256(data: string): string {
    const hash = crypto.createHash('sha256');
    hash.update(data);
    return hash.digest('hex');
}

export function getExcelString(value) {
    if (!value) {
        return ""
    }
    let localValue = value.replace(/\*/g, "")
    localValue = localValue.replace(/\[/g, "")
    localValue = localValue.replace(/\]/g, "")
    localValue = localValue.replace(/:/g, "")
    localValue = localValue.replace(/\?/g, "")
    localValue = localValue.replace(/\\/g, "")
    localValue = localValue.replace(/\//g, "")
    return localValue
}

export function truncateString(value, maxLength) {
    if (!value) {
        return "";
    }

    let cleanedValue = getXMLString(value);

    if (cleanedValue.length <= maxLength) {
        return cleanedValue;
    }

    let truncated = cleanedValue.substring(0, maxLength);
    const lastSpace = truncated.lastIndexOf(" ");

    if (lastSpace > 0 && lastSpace > maxLength - 10) {
        truncated = truncated.substring(0, lastSpace);
    }

    return truncated;
}
